<script setup lang="ts">
//
</script>

<template>
  <div
    class="hidden grid-cols-3 gap-4 md:grid [&>div]:h-[349px] [&>div]:rounded-lg [&>div]:bg-white"
  >
    <div v-for="n in 12" :key="n" />
  </div>
</template>
